import angular from 'angular';
import { ZipCodeValidator as validator } from './zip-code.validator';

export const ZipCodeValidator = angular
  .module('angular-common.validators.zip-code', [])
  .directive('zipCode', validator);
